import React from 'react';
import { Link } from 'react-router-dom';
import PublicSiteFooter from './PublicSiteFooter';
import './InfoPages.css';

function UserAgreement({ theme = 'dark' }) {
  const isDark = theme === 'dark';
  return (
    <div className={`info-page-shell ${isDark ? 'info-page-dark' : 'info-page-light'}`}>
      <div className="info-page-card">
        <header className="info-page-header">
          <div className="info-page-badge">Legal</div>
          <h1>User Agreement</h1>
          <div className="info-page-disclaimer" style={{marginTop: '8px', padding: '10px', background: 'rgba(255, 255, 255, 0.03)', borderRadius: '4px'}}>
            <strong>Beta / Free Tier Disclaimer:</strong> Redacto is currently in a FREE launch / beta phase. Billing and paid subscription features are disabled at present. This launch does not obligate users to any charges.
          </div>
        </header>

        <div className="info-page-body info-page-body-readable">
          <p>
            The User Agreement references the Redacto <Link to="/terms">Terms of Service</Link> and <Link to="/privacy-policy">Privacy Policy</Link>.
            By using Redacto you agree to these documents. During the current free launch, billing features are disabled and
            users will not be charged.
          </p>

          <p>
            For enterprise or paid deployments, the order form or separate enterprise agreement will govern commercial terms.
            Contact partnerships@redacto.net for enterprise inquiries.
          </p>

          <p><strong>End of Agreement</strong></p>
        </div>
      </div>
      <PublicSiteFooter />
    </div>
  );
}

export default UserAgreement;
